<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-body">
            <p class="lead">
              To find your receipt, please enter your receipt identifier.
            </p>

            <p>
              It's usually two short words and a number, for example:<br />
              <code>bright-shore-73</code>
            </p>

            <hr />

            <div class="row">
              <div class="col-xs-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                <form>
                  <div class="form-group form-group-lg mb-3">
                    <label for="receiptSlug">Receipt identifier</label>
                    <input
                      type="text"
                      id="receiptSlug"
                      class="form-control form-control-lg"
                      placeholder="bright-shore-73"
                      aria-label="Receipt Identifier"
                      maxlength="16"
                      v-model="receiptSlug"
                      autofocus
                    />
                    <small id="receiptSlugHelp" class="form-text text-muted">
                      This should have been provided after your transaction.
                    </small>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg btn-block"
                    @click="goToReceiptSearch()"
                  >
                    Find receipt &nbsp;
                    <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data: () => {
    return {
      receiptSlug: null
    };
  },
  methods: {
    goToReceiptSearch: function() {
      if (this.receiptSlug) {
        this.$router.push({
          path: `/${this.receiptSlug}`
        });
      }
    }
  }
};
</script>
